import React from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import KitchenIcon from "@mui/icons-material/Kitchen";
import { SectionTitle } from "./StyledComponents";
import { convertToMetric } from "../../../../../utils/unitConversion";
import decimalToFraction from "../../../../../utils/decimalToFraction";
import NewColors from "../../../../../themes/NewColors";

const RecipeIngredients = ({ ingredients }) => {
  if (!ingredients || ingredients.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <SectionTitle variant="h5">
        <KitchenIcon />
        Ingredients
      </SectionTitle>
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          mt: 2,
          mb: 1,
          backgroundColor: "background.paper",
        }}
      >
        <Grid container>
          {/* Split ingredients into two equal columns */}
          {[0, 1].map((columnIndex) => {
            const midPoint = Math.ceil(ingredients.length / 2);
            const startIndex = columnIndex === 0 ? 0 : midPoint;
            const endIndex = columnIndex === 0 ? midPoint : ingredients.length;
            const columnIngredients = ingredients.slice(startIndex, endIndex);

            return (
              <Grid item xs={12} md={6} key={columnIndex}>
                <List disablePadding>
                  {columnIngredients.map((ingredient, index) => {
                    const actualIndex = startIndex + index;
                    return (
                      <React.Fragment key={ingredient.id || actualIndex}>
                        <ListItem sx={{ py: 1.5 }}>
                          <ListItemText
                            primary={
                              <Stack direction="row" spacing={2}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    width: "40%",
                                    fontWeight: "500",
                                    color: "text.secondary",
                                  }}
                                >
                                  {ingredient.amount
                                    ? decimalToFraction(ingredient.amount)
                                    : ""}{" "}
                                  {ingredient.unit}
                                  {(() => {
                                    const metricConversion = convertToMetric(
                                      ingredient.amount,
                                      ingredient.unit,
                                    );
                                    if (metricConversion) {
                                      const { metricAmount, metricUnit } =
                                        metricConversion;
                                      return (
                                        <span
                                          style={{
                                            color: NewColors.text.secondary,
                                            fontSize: "0.9em",
                                          }}
                                        >
                                          {" "}
                                          ({metricAmount}
                                          {metricUnit})
                                        </span>
                                      );
                                    }
                                    return null;
                                  })()}
                                </Typography>
                                <Typography variant="body1">
                                  {ingredient.name}
                                </Typography>
                              </Stack>
                            }
                          />
                        </ListItem>
                        {index < columnIngredients.length - 1 && (
                          <Divider component="li" />
                        )}
                      </React.Fragment>
                    );
                  })}
                </List>
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </Box>
  );
};

export default RecipeIngredients;